/**
 * API base-URL resolution.
 *
 * In dev, VITE_API_BASE_URL is empty → paths stay relative (`/api/...`) and the
 * Vite dev server proxies them to the local API worker (:8787).
 *
 * In prod, VITE_API_BASE_URL is `https://api.provenleap.com` → API calls target
 * the API worker directly. Without this, a relative `/api/...` fetch hits the
 * Pages origin (provenleap.com), which serves `index.html` for every path — so
 * the response is HTML and callers fail with "Unexpected token '<' … not valid
 * JSON". api.provenleap.com is same-site with provenleap.com, so the session
 * cookies still flow.
 */
const API_BASE = import.meta.env.VITE_API_BASE_URL || "";

/**
 * Prefix a relative `/api/...` path with the configured API base. Absolute URLs
 * (http/https) are returned unchanged, so existing callers that already build a
 * full URL are unaffected.
 */
export function apiUrl(path: string): string {
  if (/^https?:\/\//i.test(path)) return path;
  return `${API_BASE}${path}`;
}
